"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeolocationDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _localStorageUtils = require("../../utils/localStorageUtils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Dialog that includes information for user that he is accessing foreign country tenant.
 */
const GeolocationDialog = ({
  foreignCountry,
  homeCountry,
  homeCountryUrl,
  open,
  onClose
}) => {
  const {
    translations,
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onCloseAndHideUntilDate = (0, _react.useCallback)(() => {
    onClose();
    (0, _localStorageUtils.setHideGeolocationUntilDate)();
  }, [onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dialog, {
    "data-testid": getTestId(_constants.DIALOG),
    open: open,
    onClose: onCloseAndHideUntilDate,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h4",
          component: "h4",
          children: formatMessage('dialogTitle', {
            foreignCountry,
            homeCountry
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: translations.dialogMessage
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          "data-testid": getTestId(_constants.HOME_COUNTRY_BUTTON),
          variant: "contained",
          color: "primary",
          href: homeCountryUrl,
          onClick: onClose,
          children: formatMessage('homeCountryButton', {
            homeCountry
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          "data-testid": getTestId(_constants.FOREIGN_COUNTRY_BUTTON),
          variant: "outlined",
          color: "default",
          onClick: onCloseAndHideUntilDate,
          children: formatMessage('foreignCountryButton', {
            foreignCountry
          })
        })]
      })]
    })
  });
};
exports.GeolocationDialog = GeolocationDialog;